//  TODO: add PROD site key (SRE have to create it)
export const addGiftCardSiteKey = {
  DEV: '6LeZUuQpAAAAADKX70X1d8jBOfDfuXkJ_2o6NKrl',
  STAGE: '6LcbUOQpAAAAAKwm7lhAOd0LM1no31H0PXWTzlo9',
  PROD: '6LfabgMqAAAAAHGMN-qKl9VuPlNTecVTESqQmPL6',
};
